<template>
    <div class='learingUpdate'>
       <backHeader back-addr="/person"></backHeader>
    </div>
</template>

<script>
import Addr from "./../utils/getAPI";
import axios from "axios";
import { Toast, MessageBox } from "mint-ui";
import backHeader from "./../components/back-header.vue";
export default {
  components: {
    backHeader
  },
  data() {
    return {

    };
  },
  props: {},
  watch: {},
  methods: {},
  filters: {},
  computed: {},
  created() {},
  mounted() {
    try {
            mui.plusReady(function() {
      let nowVersion;
      let remoteVersion;
      let wgtName;
      // 获取本地应用资源版本号
      plus.runtime.getProperty(plus.runtime.appid, function(inf) {
        //获取当前版本号
        nowVersion = inf.version;
        console.log("version is:");
        console.log(nowVersion);

        axios
          .get(Addr.getAliYunAddr() + "updateApk/version.txt"+"?random="+Math.random())
          .then(res => {
            
            var data=res.data;
            remoteVersion=data.split("&&")[0];
            wgtName=data.split("&&")[1];
            console.log("remote version is:");
            console.log(remoteVersion);
            console.log("wgt name is:");
            console.log(wgtName);

            nowVersion = nowVersion.replace(/\./g, "");
            remoteVersion = remoteVersion.replace(/\./g, "");
            //比对版本号
            if (remoteVersion > nowVersion) {
              plus.nativeUI.confirm(
                "应用有新版本，是否立即下载更新？",
                function(event) {
                  if (event.index == 1) {
                    plus.nativeUI.showWaiting();
                    //创建下载管理对象
                    var dtask = plus.downloader.createDownload(
                      Addr.getAliYunAddr() + "/updateApk/"+wgtName,
                      {},
                      function(d, status) {
                        // 下载完成
                        if (status == 200) {
                          //下载成功后的回调函数
                          plus.nativeUI.toast("下载成功，准备安装" + d.filename);
                          //安装程序，第一个参数是路径，默认的下载路径在_downloads里面
                          plus.runtime.install(
                            "_downloads/"+wgtName,
                            {force:true},
                            function() {
                              plus.nativeUI.toast("安装成功,将重启应用！");
                              plus.runtime.restart();
                            },
                            function() {
                              plus.nativeUI.toast("安装失败");
                            }
                          );
                          plus.nativeUI.closeWaiting();
                        } else {
                          alert("下载失败 " + status);
                        }
                      }
                    );
                    //dtask.addEventListener( "statechanged", onStateChanged, false );
                    dtask.start(); //开始下载任务

                  }
                },
                "软件更新",
                ["取消", "确认"]
              );
            }
          })
          .catch(err => {
            console.log(err);
          });
      });
    });
    } catch (error) {
        console.log(error)
    }

  },
  destroyed() {}
};
</script>

<style scoped>
#about {
  width: 100%;
  height: 100%;
}

#about-img {
  width: 100%;
}

p {
  margin-left: 15px;
  margin-right: 15px;
}
</style>


// WEBPACK FOOTER //
// src/module-person/update.vue